import { User, UserCheck } from "lucide-react";

/**
 * Per-subscriber occupancy indicator, shown next to a GIG-#### device id in
 * the PON / VDSL inventory grids.
 *
 *   occupied === true   → green UserCheck ("a live Gigafy user is moved in")
 *   occupied === false  → muted User ("vacant — no live user")
 *   occupied == null    → nothing rendered (unknown: no device match, or
 *                         occupancy never collected for this device)
 *
 * Occupancy comes from gigafy_device_occupancy, refreshed by the
 * scheduled mikrotik_pppoe_sync (every 30 min, portal data on a 24 h
 * TTL) and the nightly gigafy_service_sync (migration 0039).
 */
export function OccupancyIcon({ occupied }: { occupied: boolean | null }) {
  if (occupied == null) return null;
  const label = occupied
    ? "Occupied — live Gigafy user"
    : "Vacant — no live user";
  const Icon = occupied ? UserCheck : User;
  return (
    <span title={label} className="inline-flex items-center align-middle">
      <Icon
        className={`h-3.5 w-3.5 ${occupied ? "text-emerald-400" : "text-slate-600"}`}
        aria-label={label}
      />
    </span>
  );
}
